export const baseUrl = 'http://localhost:3000/'
// Dev override so a worktree can point at its own backend port:
//   REACT_APP_API_URL=http://localhost:3011/api/ npm start
const devApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/'
const devSocketUrl = process.env.REACT_APP_SOCKET_URL || devApiUrl.replace(/\/api\/?$/, '')
export const apiUrl = process.env.NODE_ENV === "production" ? 'https://cirugia-tenant.herokuapp.com/api/' : devApiUrl
export const socketUrl = process.env.NODE_ENV === "production" ? 'https://cirugia-tenant.herokuapp.com' : devSocketUrl
